<template>
  <div class="student-tag-list">
    <el-checkbox-group v-model="checkList" @change="deleteBatchClick">
      <el-tag
        style="cursor: pointer"
        v-for="tag in studentTagList"
        :key="tag.id"
        :disable-transitions="true"
        @click.stop="studentTabClick(tag)"
      >
        {{ tag.labelName }}
        <div
          class="course-update"
          v-show="tag.remark == 'update'"
          @click.stop="updateClick(tag)"
        >
          <i class="iconfont icon-update" />
        </div>
        <div
          class="course-delete"
          v-show="tag.remark == 'delete'"
          @click.stop="deleteClick(tag)"
        >
          <i class="iconfont icon-cancel" />
        </div>
        <div class="course-deleteBatch" v-show="tag.remark == 'deleteBatch'">
          <el-checkbox :label="tag.id"></el-checkbox>
        </div>
      </el-tag>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkList: [],
      checkAllList: [],
      checkAllType: this.checkAll,
    };
  },
  props: {
    studentTagList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    editShow: {
      type: String,
    },
    checkAll: {
      type: Boolean,
    },
  },
  created() {},
  watch: {
    checkAll: {
      handler(val) {
        if (val) {
          let tagList = this.studentTagList;
          tagList.map((item) => {
            this.checkList.push(item.id);
          });
          this.$emit("deleteBatchList", this.checkList);
          return;
        }
        this.checkList = [];
        this.$emit("deleteBatchList", this.checkList);
      },
    },
  },
  methods: {
    // 点击tag-查看标签对应的学生列表
    studentTabClick(e) {
      // console.log("点击了tag:", e);
      this.get(this.$url.selectLabelConditionStudent + "/" + e.id).then(
        (res) => {
          // console.log("查询标签绑定的学生信息==>", res);
          if (res.code !== 200)
            return this.$message.error(res.msg || "获取标签绑定学生列表失败");
          if (!res.data.length)
            return this.$message.warning("该标签暂无绑定学生列表");
          this.$emit("tagBindStudentListDialogShow", res.data);
        }
      );
    },
    deleteBatchClick(e) {
      this.checkAllType =
        JSON.stringify(e) === JSON.stringify(this.checkAllList) ? true : false;
      // console.log(this.checkAllType);
      this.$emit("deleteBatchAllType", this.checkAllType);
      this.$emit("deleteBatchList", e);
    },
    // 删除标签
    deleteClick(e) {
      this.$confirm("是否删除该标签?", "删除标签", {
        confirmButtonText: "确定",
        cancelButtomText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.$emit("delTag", e);
        })
        .catch(() => {});
    },
    updateClick(e) {
      // console.log(e);
      this.$emit("reviseShowType", true);
      this.$emit("reviseTag", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./student-tag-list.scss";
</style>
